import { ButtonProps } from "@src/components/ui-components/Buttons/Button/Button";
import PhoneNumberInput from "@src/components/ui-components/Inputs/PhoneNumberInput/PhoneNumberInput";
import { useState } from "react";
import { ModalPopup } from "../ModalPopup/ModalPopup";

interface PhoneNumberFieldModalPopupProps {
  id: string;
  title: string;
  placeholder: string;
  onSubmit: (popUpId: string, name: string) => void;
  actionTitle?: string;
  actionButtonType?: ButtonProps["type"];
  defaultText?: string;
}

export const PhoneNumberFieldModalPopup = (props: PhoneNumberFieldModalPopupProps) => {
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>(props.defaultText ?? "");
  //const [country, setCountry] = useState<CountryData | {}>();
  return (
    <ModalPopup
      id={props.id}
      title={props.title}
      onActionClicked={() => props.onSubmit(props.id, (phoneNumber && phoneNumber[0] !== "+" ? "+" : "") + phoneNumber)}
      actionTitle={props.actionTitle}
      actionButtonType={props.actionButtonType}
      children={
        <div>
          <PhoneNumberInput phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} />
        </div>
      }
    />
  );
};
